module.exports = __webpack_public_path__ + "img/calc.5525e720.svg";